"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization_1 = require("../../localization");
exports.noComparisonRowSubtitle = function () {
    return localization_1.Messages.metricsNoComparisonRowSubtitle;
};
//# sourceMappingURL=noComparisonSubtitle.js.map